import React from "react";
import { Grid } from "@material-ui/core";
import "./style.scss";

const LoginContainerPanel = ({ children }) => {
  return <div className="custom-login-container-panel">{children}</div>;
};

export default LoginContainerPanel;
